import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=74b13650"
import script from "./Summary.js?vue&type=script&lang=js&external"
export * from "./Summary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports